import jsx from '../lib/jsx'
import { dispatchEvent } from '../lib/helpers'

addEventListener('DOMContentLoaded', () => {
    
    // const fileSelects = document.querySelectorAll('div.field_file_browser')
    // for (let a = 0; a < fileSelects.length; a++) {
    //     initFileBrowser(fileSelects[a])
    // }
    const typeField = document.querySelectorAll('#question_type');

    if (typeField.length > 0) {
        
        document.addEventListener("keydown", (event: KeyboardEvent) => {
            const target = event.target as HTMLElement;
            if (target.tagName !== "TEXTAREA" && target instanceof HTMLInputElement) {
                if (event.key === "Enter") {
                    event.preventDefault();
                }
            }
        });


        const questionTypeElement = document.getElementById("question_type");
        if (questionTypeElement) {
            questionTypeElement.addEventListener("change", switchQuestionType);
        }

        addFunctionsToPremadeFields();
        switchQuestionType();
        addChoiceField()
    }
})

var optionCounter = 0;
function addChoiceField(deletable = true) {
    var optionHolder = document.querySelector('#options');

    var optiondiv = document.createElement('div');
    var input = document.createElement('input');

    input.textContent = 'text';
    input.maxLength = 255;
    input.name = 'choiceoption-' + optionCounter;

    input.addEventListener("input", function () {
        if (optionHolder.lastElementChild.children[0] == input) {
            addChoiceField();
        }
    });

    if (deletable) {
        input.addEventListener("input", function () {
            if (input.value.length == 0) {
                optiondiv.remove();
            }
        });
    }

    optiondiv.appendChild(input);
    optionHolder.appendChild(optiondiv);
    optionCounter++;
}

function switchQuestionType() {
    var type = (document.querySelector('#question_type') as HTMLInputElement).value

    let childrenOpen = document.querySelector('#field_type_open').parentElement.children;
    let childrenMultiple = document.querySelector('#field_type_multiple').parentElement.children;
    switch (type) {
        case 'multiple':
            (document.querySelector('#options') as HTMLElement).style.display = 'block';
            for(var i = 0; i < childrenOpen.length; i++) {
                (childrenOpen[i] as HTMLElement).style.display = 'none';
            }

            for (var i = 0; i < childrenMultiple.length; i++) {
                (childrenMultiple[i] as HTMLElement).style.display = 'block';
            }
            break;
        case 'open':
            (document.querySelector('#options') as HTMLElement).style.display = 'none';

            for (var i = 0; i < childrenOpen.length; i++) {
                (childrenOpen[i] as HTMLElement).style.display = 'block';
            }

            for (var i = 0; i < childrenMultiple.length; i++) {
                (childrenMultiple[i] as HTMLElement).style.display = 'none';
            }
            break;
        default:
            (document.querySelector('#options') as HTMLElement).style.display = 'block';
            for (var i = 0; i < childrenOpen.length; i++) {
                (childrenOpen[i] as HTMLElement).style.display = 'none';
            }

            for (var i = 0; i < childrenMultiple.length; i++) {
                (childrenMultiple[i] as HTMLElement).style.display = 'block';
            }
            break;
    }
}

function addFunctionsToPremadeFields() {
    let optionHolder = document.querySelector('#options');
    for (var i = 0; i < optionHolder.children.length; i++) {
        let optiondiv = optionHolder.children[i];
        if (optiondiv.classList.contains('option-header')) {
            continue;
        }
        let input = optionHolder.children[i].children[0];
        
        //set the optionCounter to the value of the last item. (just keep overriding it, lol)
        //why the fuck is there suddenly an extra div layer? Whatever...
        input = input.children[0];
        const id = input.getAttribute('name').replace("choiceoption-", "")
        optionCounter = parseInt(id);

        input.addEventListener("input", function () {
            if (optionHolder.lastElementChild.children[0] == input) {
                addChoiceField();
            }
        });
        input.addEventListener("input", function () {
            if ((input as HTMLInputElement).value.length == 0) {
                optiondiv.remove();
            }
        });

        optionCounter++;
    }
}